import { UserCoursesRequest } from '@klab-berlin/api-sdk/lib/types/responses/CourseRegistration';
import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
  createCourseRegistration,
  buildCourseLaunchLink,
  getCourseRegistration,
  getCertifiedCourseRegistrations,
  getUpdatedCourseRegistration,
  getUserCourses,
};

function createCourseRegistration(mindItemId: string) {
  notifyBugsnagNetwork('course', 'createCourseRegistration', { mindItemId });
  return handleUnauthorized(() => api.course.createCourseRegistration(mindItemId));
}

function buildCourseLaunchLink(mindItemId: string) {
  notifyBugsnagNetwork('course', 'buildCourseLaunchLink', { mindItemId });
  return handleUnauthorized(() => api.course.buildCourseLaunchLink(mindItemId));
}

function getCourseRegistration(mindItemId: string) {
  notifyBugsnagNetwork('course', 'getCourseRegistration', { mindItemId });
  return handleUnauthorized(() => api.course.getCourseRegistration(mindItemId));
}

function getCertifiedCourseRegistrations(userId: string) {
  notifyBugsnagNetwork('course', 'getCertifiedCourseRegistrations', { userId });
  return handleUnauthorized(() => api.course.getCertifiedCourseRegistrations(userId));
}

function getUpdatedCourseRegistration(userId: string, courseId: string) {
  notifyBugsnagNetwork('course', 'getUpdatedCourseRegistration', { userId, courseId });
  return handleUnauthorized(() => api.course.getUpdatedCourseRegistration(userId, { courseId }));
}

function getUserCourses(userId: string, query: UserCoursesRequest) {
  notifyBugsnagNetwork('course', 'getUserCourses', { userId, query });
  return handleUnauthorized(() => api.course.getUserCourses(userId, query));
}

export default service;
